import { t } from '../../../../lang';
import { createRootModal } from '../../RootModal';
import './AmlHighRisk.scss';

const AmlHighRisk = createRootModal(() => {
	return (
		<div className='LearnAboutAmlRisk'>
			<div className='LearnAboutAmlRisk_content'>
				<div className='LearnAboutAmlRisk_content_text'>
					<p className='LearnAboutAmlRisk_content_regular'>
						{t('High-risk % shows the portion of funds associated with high-risk sources.')}
					</p>
				</div>

				<div className='LearnAboutAmlRisk_content_text'>
					<p className='LearnAboutAmlRisk_content_text_bold'>{t('What does this mean?')}</p>
					<p>
						{t(
							'This percentage reflects the combined contribution of funds linked to sources classified as high risk, such as sanctions, scams, stolen funds, terrorism financing, and other suspicious activities.\nA higher value does not represent the overall AML risk level of the address. It indicates that part of the funds originates from high-risk sources and may require additional attention during compliance checks.'
						)}
					</p>
				</div>

				<div className='LearnAboutAmlRisk_content_text'>
					<p className='LearnAboutAmlRisk_content_text_bold'>{t('What should you do?')}</p>
					<p>
						{t(
							'Review the AML details to understand the source and use of funds.\nUse this information to make an informed decision before interacting with these assets.'
						)}
					</p>
				</div>
			</div>
		</div>
	);
});

export default AmlHighRisk;
